import { Inject, Service } from 'vue-di-container';

import { UserModel } from '@/models/user';
import HttpService from './httpService';

@Service()
export default class UserService {
  @Inject(HttpService) public httpService!: HttpService;
  user!:UserModel;
  public async getUser(): Promise<UserModel> {
    if (this.user) {
      return this.user;
    };
    const url = 'api/UserInfo';
    const res = await this.httpService.httpInstance.get<UserModel>(url);
    return res.data;
  }
}
